import React, { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { DataExperienceProvider } from '../context/dataExperienceContext';
import { TravelersProvider } from '../context/travelersContext';
import { CurrencyProvider } from '../context/currencyContext';
import useExperienceData from '../hooks/useExperienceData';
import Loader from '../components/Loader/Loader';

interface ExperienceProvidersLayoutProps {
  experienceId?: string;
  children?: React.ReactNode;
}

interface InnerContentProps {
  experienceId?: string;
  children?: React.ReactNode;
}

const InnerContent: React.FC<InnerContentProps> = ({ children, experienceId }) => {
  const { id: paramExperienceId } = useParams();
  const { loading, experience, fetchData, error } = useExperienceData();
  const id = experienceId || paramExperienceId;

  useEffect(() => {
    if (id) fetchData(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  if (loading || !experience || error) {
    return <Loader />;
  }

  return (
    <TravelersProvider>
      <CurrencyProvider productCurrencyCode={experience.availabilitySchedule.currency}>
        {children || <Outlet />}
      </CurrencyProvider>
    </TravelersProvider>
  );
};

const ExperienceProvidersLayout: React.FC<ExperienceProvidersLayoutProps> = ({ children, experienceId }) => {
  return (
    <DataExperienceProvider>
      <InnerContent experienceId={experienceId} children={children} />
    </DataExperienceProvider>
  );
};

export default ExperienceProvidersLayout;
